<div class="w-full h-full bg-[#232323] text-white min-h-screen overflow-auto">
  <!-- Header -->
  <div class="px-8 md:px-16 pt-12 pb-6">
    <div class="flex items-center gap-4 mb-2">
      <div class="p-3 bg-gradient-to-br from-[#E4811E] to-orange-600 rounded-2xl shadow-lg shadow-[#E4811E]/20">
        <mat-icon class="text-white icon-size-8" svgIcon="feather:award"></mat-icon>
      </div>
      <h1 class="text-4xl font-extrabold">Meus Certificados</h1>
    </div>
    <p class="text-lg text-white/70 mt-2">
      Aqui estão todos os certificados que você conquistou ao concluir módulos nas trilhas de aprendizado.
    </p>
  </div>

  <!-- Conteúdo -->
  <div class="px-8 md:px-16 pb-12">
    <!-- Loading -->
    <div *ngIf="loading" class="flex items-center justify-center py-16">
      <mat-spinner diameter="40" class="text-[#E4811E]"></mat-spinner>
    </div>

    <!-- Empty State -->
    <div *ngIf="!loading && certificados.length === 0" class="text-center py-16">
      <div class="w-20 h-20 rounded-full bg-zinc-800 flex items-center justify-center mx-auto mb-4">
        <mat-icon class="text-white/30 icon-size-10">workspace_premium</mat-icon>
      </div>
      <h3 class="text-xl font-semibold text-white mb-2">Nenhum certificado ainda</h3>
      <p class="text-white/50">Complete módulos nas trilhas para ganhar certificados!</p>
    </div>

    <!-- Lista de certificados -->
    <div *ngIf="!loading && certificados.length > 0">
      <mat-accordion class="certificados-accordion">
        <mat-expansion-panel *ngFor="let trilha of certificadosPorTrilha" class="certificado-panel !bg-zinc-900 !rounded-xl !border !border-zinc-800 mb-4">
          <mat-expansion-panel-header class="panel-header">
            <mat-panel-title class="panel-title">
              <mat-icon class="text-[#E4811E] mr-3">school</mat-icon>
              <span class="text-lg font-semibold text-white">{{ trilha.trilhaNome }}</span>
              <span class="ml-auto text-sm text-white/60">({{ trilha.certificados.length }} certificado<span *ngIf="trilha.certificados.length > 1">s</span>)</span>
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 pt-4">
            <div *ngFor="let certificado of trilha.certificados"
              class="flex flex-col items-center text-center bg-zinc-800/50 rounded-xl p-5 border border-zinc-700 hover:border-[#E4811E]/50 transition-all hover:scale-[1.02]">
              
              <div class="w-16 h-16 rounded-full bg-[#E4811E]/10 flex items-center justify-center mb-4">
                <mat-icon class="text-[#E4811E] icon-size-8">workspace_premium</mat-icon>
              </div>
              
              <p class="text-lg font-semibold text-white mb-1">
                {{ certificado.moduloNome }}
              </p>
              
              <p class="text-sm text-white/60 mb-4">
                Concluído em: {{ certificado.dataConclusao | date:'dd/MM/yyyy' }}
              </p>
              
              <button mat-flat-button class="!bg-[#E4811E] hover:!bg-[#d4751a] !text-white transition-colors" (click)="downloadCertificado(certificado)">
                <mat-icon class="mr-1">download</mat-icon>
                Baixar PDF
              </button>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
  </div>
</div>
